"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formSummary = require("./form-summary.style");

var _icon = _interopRequireDefault(require("../../icon"));

var _useLocale = _interopRequireDefault(require("../../../hooks/__internal__/useLocale"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Summary = ({
  type,
  errors,
  warnings
}) => {
  const l = (0, _useLocale.default)();
  const messages = {
    errors,
    warnings
  };

  if (messages[type]) {
    return /*#__PURE__*/_react.default.createElement(_formSummary.StyledInternalSummary, {
      type: type,
      "data-element": type
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      type: type.slice(0, -1)
    }), /*#__PURE__*/_react.default.createElement("span", null, l.errors.messages.formSummary(errors, warnings, type)));
  }

  return null;
};

Summary.propTypes = {
  type: _propTypes.default.oneOf(["errors", "warnings"]),
  errors: _propTypes.default.number,
  warnings: _propTypes.default.number
};

const FormSummary = props => /*#__PURE__*/_react.default.createElement(_formSummary.StyledFormSummary, {
  showSummary: props.errors > 0 || props.warnings > 0,
  "data-element": "form-summary"
}, /*#__PURE__*/_react.default.createElement(Summary, _extends({
  type: "errors"
}, props)), /*#__PURE__*/_react.default.createElement(Summary, _extends({
  type: "warnings"
}, props)), props.children);

FormSummary.propTypes = {
  children: _propTypes.default.node,
  errors: _propTypes.default.number,
  warnings: _propTypes.default.number
};
var _default = FormSummary;
exports.default = _default;